import { axiosInstance as axios } from "../../axios/axios";
import * as Action from "../actions/index";
import { localStorageFunc } from "./../../utils/localStorage";
// Edit the user detail
export const editUser = (id, data, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      await axios.patch(`api/dashboard/users/${id}`, data, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      setLoading(true);
      dispatch({ type: Action.LOGIN, payload: { user: data, token } });
      setLoading(false);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: "Update Successful", type: "success" },
      });
    } catch (err) {
      if (err.response) {
        dispatch({
          type: Action.CREATE_ERROR,
          payload: { msg: err.response.data.message, type: "error" },
        });
      }
      setLoading(false);
    }
  };
};

// edit the user password in frontend
export const editPassword = (id, navigate, data, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);
      await axios.patch(`api/dashboard/users/${id}`, data, {
        headers: { authorization: `Bearer ${token}` },
      });
      setLoading(true);
      dispatch({
        type: Action.CREATE_ERROR,
        payload: {
          msg: "Password Updated.Redirecting to login page",
          type: "success",
        },
      });
      localStorageFunc("remove");
      dispatch({ type: Action.LOGOUT });

      setLoading(true);
      navigate("/login");
    } catch (err) {
      if (err.response) {
        dispatch({
          type: Action.CREATE_ERROR,
          payload: { msg: err.response.data.message, type: "error" },
        });
      }
      setLoading(false);
    }
  };
};
export const deleteUser = (id, setLoading, token) => {
  return async (dispatch) => {
    try {
      setLoading(true);

      await axios.delete(`api/dashboard/users/${id}`, {
        headers: {
          authorization: `Bearer ${token}`,
        },
      });
      console.log("Delete user");
      dispatch({ type: Action.DELETE_USER, payload: id });
      dispatch({
        type: Action.CREATE_ERROR,
        payload: { msg: "User deleted ", type: "success" },
      });
    } catch (err) {
      if (err.response) {
        dispatch({
          type: Action.CREATE_ERROR,
          payload: { msg: err.response.data.message, type: "error" },
        });
      }
      setLoading(false);
    }
  };
};
